import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(19, 19, 19, 0.5);
  font-family: "Noto Sans", sans-serif;
  line-height: 1.4;
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.05fr;
  width: 100%;
  max-width: 980px;
  max-height: calc(100vh - 48px);
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(19, 19, 19, 0.12);

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`;

export const Left = styled.div`
  background: linear-gradient(141deg, #cdeee3 -406.62%, #fff 158.31%);
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;

  @media (max-width: 820px) {
    display: none;
  }
`;

export const Illustration = styled.img`
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
  object-fit: contain;
`;

export const BenefitList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  font-size: 13px;
  line-height: 1.45;
  color: #383839;
  border-bottom: 1px solid #d8ece5;

  &:last-child {
    border-bottom: none;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const Right = styled.div`
  position: relative;
  padding: 32px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (max-width: 480px) {
    padding: 28px 20px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: transparent;
  color: #131313;
  cursor: pointer;
  padding: 4px;
  display: flex;

  &:hover {
    opacity: 0.7;
  }
`;

export const Eyebrow = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #01754f;
  margin-bottom: 4px;
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: #111219;
  line-height: 1.3;
  margin: 0 0 16px;
  padding-right: 32px;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const PlanGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  /* Espaço extra no topo para o badge flutuante do plano em destaque. */
  margin: 6px 0 12px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const PlanCard = styled.button`
  position: relative;
  appearance: none;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: ${({ $hasBadge }) => ($hasBadge ? "16px 14px 12px" : "12px 14px")};
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  background: ${({ $active }) => ($active ? "#E6F7F2" : "#fff")};
  border: 1.5px solid ${({ $active }) => ($active ? "#01AB7D" : "#E7E8EC")};
  transition: border-color 0.15s, background 0.15s;
`;

export const PlanInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PlanName = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #131313;
`;

export const PlanPrice = styled.div`
  font-size: 13px;
  color: #5e5e60;
`;

export const PlanNote = styled.span`
  font-size: 11px;
  color: #888;
`;

/* Flutua sobre a borda superior do card para não competir com o nome do plano. */
export const SaveBadge = styled.span`
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 2px 10px;
  border-radius: 999px;
  background: #01ab7d;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: 0.2px;
`;

export const Radio = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  border: 2px solid ${({ $active }) => ($active ? "#01AB7D" : "#cfd1d6")};

  &::after {
    content: "";
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: #01ab7d;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    transition: opacity 0.15s;
  }
`;

export const FeaturesList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5e5e60;

  svg {
    flex-shrink: 0;
  }
`;

export const DiscountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 8px;
  background: #01ab7d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 12px;
  padding-top: 12px;
  border-top: 1px solid #e7e8ec;

  span {
    font-size: 15px;
    font-weight: 700;
    color: #131313;
  }

  strong {
    font-size: 20px;
    font-weight: 700;
    color: #131313;
  }
`;

export const TotalPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const TotalNote = styled.span`
  font-size: 11px !important;
  font-weight: 400 !important;
  color: #888 !important;
`;

export const OriginalPrice = styled.span`
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #888 !important;
  text-decoration: line-through;
`;

export const SwitchCardBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 8px 10px;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
  background: #fafbff;
  cursor: pointer;

  span {
    font-size: 13px;
    font-weight: 600;
    color: #01ab7d;
  }
`;

export const CardFormArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .MuiButton-root {
    padding: 13px !important;
    border-radius: 8px !important;
    font-size: 15px !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: #e7e8ec !important;
    border-radius: 8px;
  }
`;

export const DisclaimerBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f4f5f9;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 12px;

  svg {
    flex-shrink: 0;
  }
`;

export const DisclaimerText = styled.p`
  font-size: 12px;
  color: #5e5e60;
  margin: 0;
  line-height: 1.45;
`;
